import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useRoomPreferenceCardStyles = makeStyles({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '9.4375rem',
    flex: '0 0 151px',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('1rem'),
    cursor: 'pointer',
    boxSizing: 'border-box',
    outline: 'none',
    userSelect: 'none',
    ...shorthands.padding('0.75rem'),

    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '0.125rem',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '0.125rem',
    },
  },

  unchecked: {
    ...shorthands.border('0.0625rem', 'solid', tokens.colorNeutralStroke1),
  },

  checked: {
    ...shorthands.border('0.0625rem', 'solid', tokens.colorBrandForeground1),
  },

  disabled: {
    cursor: 'not-allowed',
  },

  hoverable: {
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3,
    },
  },

  checkbox: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
  },

  title: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: tokens.lineHeightBase200,
    marginBottom: '0.125rem',
    width: '100%',
    paddingRight: '1.25rem',
    boxSizing: 'border-box',
  },

  description: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground2,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    lineHeight: tokens.lineHeightBase200,
    minHeight: `calc(${tokens.lineHeightBase200} * 2)`,
    marginBottom: '0.25rem',
    width: '100%',
  },

  capacity: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase200,
    marginTop: 'auto',
    width: '100%',
  },

  disabledText: {
    color: tokens.colorNeutralForegroundDisabled,
  },
});
